<div>
  <label class="form-label">Optional Team Name</label>
  <input
    #teamName="ngModel"
    class="form-control"
    required
    maxlength="20"
    [(ngModel)]="match.teams.optional.name"
    >
</div>

@if (!match.teams.optionalEnabled) {
  <button
    type="button"
    class="btn btn-success"
    [disabled]="teamName.invalid"
    (click)="enable()"
  >Show</button>
} @else {
  <button
    type="button"
    class="btn btn-danger"
    (click)="disable()"
  >Hide</button>
}

